// A delayed rejection from an earlier login must not clear a newer session.
export function concernsCurrentSession(error, tokenKey) {
  const current = localStorage.getItem(tokenKey);
  if (!current) return true;
  const headers = error?.config?.headers;
  const authorization = headers?.get?.("Authorization") || headers?.Authorization || headers?.authorization;
  return authorization === `Bearer ${current}`;
}
